import React from "react";
import {Supplier, SupplierRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {Box, Grid} from "@mui/material";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import {FormAddress} from "../../../../components/form/form_inputs/form_address";
import FormAutocomplete from "../../../../components/form/form_inputs/form_autocomplete";
import {types} from "../../../../components/form/types";
import {RecordAttachments} from "../../../../components/record_attachments";

export const SupplierEditPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(SupplierRestControllerApiFactory);

    const form = useForm({
        fetcher: (id) => ctrl.getSupplier(id),
        updater: (bean) => ctrl.saveSupplier(bean),
        remover: (id) => ctrl.deleteOrDismissSupplier(id),
        factory: () => ({address: {}} as Supplier),
    } as UseFormProps<Supplier>);

    return (
        <>
        <FormContent form={form} title={"Formulario de proveedor"}>
            <FormInput field={"name"} label={"Nombre"}/>

            <Grid container spacing={3}>
                <Grid item sm={3}>
                    <FormInput field={"shortName"} label={"Nombre corto"}/>
                </Grid>
                <Grid item sm={3}>
                    <FormInput field={"nif"} label={"NIF"}/>
                </Grid>
                <Grid item sm={3}>
                    <FormInput field={"vatEu"} label={"NIF Intracomunitario (UE)"}/>
                </Grid>
                <Grid item sm={3}>
                    <FormAutocomplete field={"accountingAccount"} label={"Cuenta contable"} type={types.accountingAccounts}/>
                </Grid>
            </Grid>

            <Grid container spacing={3}>
                <Grid item sm={6}>
                    <FormInput field={"email"} label={"Email"} type="email"/>
                </Grid>
                <Grid item sm={6}>
                    <FormInput field={"telephone"} label={"Teléfono"}/>
                </Grid>
            </Grid>

            <FormInput field={"iban"} label={"IBAN"}/>

            <FormAddress field={"address"}/>

            <FormInput field={"observation"} label={"Observaciones"} rows={4}/>
        </FormContent>
        <Box sx={{mt: 3}}>
            <RecordAttachments recordType="SUPPLIER" recordId={form.getId()}/>
        </Box>
        </>
    );
};
